import { Classes, Drawer, DrawerProps, DrawerSize } from '@blueprintjs/core';
import { StartingMaterialPriceItem } from '@retro-ui/shared';
import cx from 'classnames';

import LoadingScreen from '../loading-screen/LoadingScreen';

import cls from './PriceSidebar.module.scss';
import Pricing from './Pricing';

export interface PriceSidebarProps extends DrawerProps {
  priceItems?: StartingMaterialPriceItem[];
  selectedDatasets: {
    id: string;
    selected_suppliers?: string[];
  }[];
}

export function PriceSidebar(props: PriceSidebarProps) {
  const { priceItems = [], selectedDatasets = [], ...restProps } = props;

  const isEmpty = priceItems.length === 0;

  return (
    <Drawer isCloseButtonShown title="Molecule prices" size={DrawerSize.STANDARD} {...restProps}>
      <div className={cx(Classes.DRAWER_BODY, cls.body)}>
        {!isEmpty && <Pricing priceItems={priceItems} selectedDatasets={selectedDatasets} />}

        {isEmpty && <LoadingScreen />}
      </div>
    </Drawer>
  );
}
